import React, { useEffect, useMemo, useRef, useState } from "react";
import "./promoCarousel.css";
import { useBrand } from "../../context/brand-context";
import http from "../../api/http";
/* Images de fond */
import promoAmen from "../../images/promoAmen.png";
import promoMg from "../../images/promoMg.png";
import { useNavigate } from "react-router-dom";

export default function PromoCarousel({ intervalMs = 5000 }) {
  const { brand } = useBrand(); // 'amen' | 'mg'
  const isAmen = brand === "amen";
  const dbName = isAmen ? "Amen" : "Amen_C";
  const apiUrl = "/api/promos";

  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const timerRef = useRef(null);
  const hoveredRef = useRef(false);

  // Définition des couleurs selon la marque pour le badge
  const theme = useMemo(() => ({
    // Amen = Rouge, Mg = Bleu (basé sur vos images)
    color: isAmen ? "#7a0f18" : "#1d4ed8",
    bgImage: isAmen ? promoAmen : promoMg
  }), [isAmen]);
  const navigate = useNavigate();

  const onView = () => {
    const codArt = item?.subtitle; // tu l’as mis = r.CodArt
    if (!codArt) return;

    // navigation vers détails + passage d'un "item" minimal
    navigate(`/produits/${encodeURIComponent(codArt)}`, {
      state: {
        item: {
          CodArt: codArt,
          LibArt: item.title,
          // optionnel: si tu as un champ image/prix dans l'API promos, mets-les ici
        },
      },
    });
  };

  // --------- Fetch des promos
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        // Appel API
        const { data } = await http.get(apiUrl, {
          headers: { "x-db": dbName },
          params: { active: true }   // retire-le si tu veux tout
        });

        // Gestion de la structure : {"rows": [...]}
        const rows = data?.rows || (Array.isArray(data) ? data : []);

        const mapped = rows.map(r => ({
          id: r.ID_CompArt,
          title: r.LibArt, // "CALANDRE CARRE KB26"
          subtitle: r.CodArt, // "01-U-TY" (servira de 'Marque')
          dateStart: r.DateD,
          dateEnd: r.DateF,
          discount: r.RemisePct || 0 // 15
        }));

        if (alive) {
          setItems(mapped);
          setI(0);
        }
      } catch (e) {
        if (alive) setErr(e?.message || "Erreur réseau");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [apiUrl, dbName]);

  // --------- Timer Auto-play
  useEffect(() => {
    if (!items.length) return;
    timerRef.current = setInterval(() => {
      if (!hoveredRef.current) setI((p) => (p + 1) % items.length);
    }, intervalMs);
    return () => clearInterval(timerRef.current);
  }, [items, intervalMs]);

  const onEnter = () => { hoveredRef.current = true; };
  const onLeave = () => { hoveredRef.current = false; };

  // Formatage de date (ex: 17 au 23 novembre 2025)
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "numeric", month: "long", year: "numeric"
    });
  };

  if (loading) return <div className="promo-skeleton">Chargement...</div>;
  if (!items.length) return null;

  const item = items[i];

  return (
    <section
      className="promo-card"
      style={{ backgroundImage: `url(${theme.bgImage})` }}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >


      {/* Contenu Texte (positionné à gauche sur la zone colorée) */}
      <div className="promo-content">
        <h2 className="promo-title">{item.title}</h2>
        <h3 className="promo-subtitle">{item.subtitle}</h3>

        <p className="promo-desc">
          Du {formatDate(item.dateStart)} au {formatDate(item.dateEnd)}, bénéficiez d’une réduction allant jusqu’à -{item.discount}%
        </p>

        <div className="promo-actions">
          <button className="btn-noir" onClick={onView}>Voir</button>
        
        </div>

      </div>

      {/* Pagination (petits points) */}
      <div className="promo-dots">
        {items.map((_, k) => (
          <span
            key={k}
            className={`dot ${k === i ? "active" : ""}`}
            onClick={() => setI(k)}
          />
        ))}
      </div>
    </section>
  );
}